import { FormType } from '../../../form-types';

export const hairLossFollowup: FormType = {
  name: 'Hair Loss Followup',
  olderVersions: ['hairLossFollowup_archived'],
  questions: [
    // 'hairLossFollowup_currentMedicalConditions',
    // 'hairLossFollowup_currentMedications',
    // 'hairLossFollowup_knownAllergies',
    {
      key: 'hairLossFollowup_healthChanges',
      next: {
        condition: {
          'hairLossFollowup_healthChanges.hairLossFollowup_healthChanges_yes':
            true
        },
        key: 'hairLossFollowup_healthChanges_yes_more',
        els: 'hairLossFollowup_medicationStatus'
      }
    },
    'hairLossFollowup_healthChanges_yes_more',
    {
      key: 'hairLossFollowup_medicationStatus',
      next: {
        condition: {
          'hairLossFollowup_medicationStatus.hairLossFollowup_medicationStatus_notWell':
            true
        },
        key: 'hairLossFollowup_medicationStatus_notWell_more',
        els: 'hairLossFollowup_medicationSideEffects'
      }
    },
    'hairLossFollowup_medicationStatus_notWell_more',
    {
      key: 'hairLossFollowup_medicationSideEffects',
      next: {
        condition: {
          'hairLossFollowup_medicationSideEffects.hairLossFollowup_medicationSideEffects_yes':
            true
        },
        key: 'hairLossFollowup_medicationSideEffects_yes_ans',
        els: 'hairLossFollowup_otherInformationOrQuestions'
      }
    },
    'hairLossFollowup_medicationSideEffects_yes_ans',
    'hairLossFollowup_otherInformationOrQuestions',

    {
      key: 'hairLossFollowup_consent',
      next: {
        condition: {
          'hairLossFollowup_consent.hairLossFollowup_consent_consent': true
        },
        key: 'hairLossFollowup_complete',
        els: 'hairLossFollowup_ineligible'
      }
    },
    'hairLossFollowup_ineligible',
    'hairLossFollowup_complete'
  ]
};
export const hairLossFollowup_archived: FormType = {
  name: 'Hair Loss Followup',
  questions: [
    'hairLossFollowup_archived_currentMedicalConditions',
    'hairLossFollowup_archived_currentMedications',
    'hairLossFollowup_archived_knownAllergies',
    'hairLossFollowup_archived_height',
    'hairLossFollowup_archived_weight',
    'hairLossFollowup_archived_healthChanges',
    'hairLossFollowup_archived_medicationStatus',
    'hairLossFollowup_archived_medicationSideEffects',
    'hairLossFollowup_archived_otherInformationOrQuestions',
    'hairLossFollowup_archived_consent'
  ]
};
